// Side-effect import: pins Luxon's default zone to UTC (see defaultZone.ts).
// Bare import so it is never tree-shaken and runs before any date is built.
import "./defaultZone.js";
import { getNowMs } from "./RooTimeService.js";
// eslint-disable-next-line
export class RooDate extends Date {
    /**
     * Static method to match Date.now()
     */
    static now() {
        return getNowMs();
    }
    static nowNoTimeTravel() {
        // eslint-disable-next-line
        return Date.now();
    }
    static getDateNoTimeTravel() {
        // eslint-disable-next-line
        return new RooDate(Date.now());
    }
    constructor(...args) {
        if (args.length === 0) {
            // Return a Date object set to your offset time
            super(getNowMs());
        }
        else {
            // Pass through parameters to the native Date constructor
            // @ts-ignore
            super(...args);
        }
        // Fix the prototype chain (Crucial for inheritance in JS)
        Object.setPrototypeOf(this, RooDate.prototype);
    }
}
//# sourceMappingURL=RooDate.js.map